/**
 * Pure display formatters shared across the "Decyzje klienta" review table's
 * pieces (table-columns.tsx, summary-panel.tsx) — hoisted here so the pl-PL
 * money format isn't hand-copied in two files. No app-wide PLN formatter
 * with this exact "no decimals + zł suffix" shape exists yet elsewhere in
 * apps/web/src/lib (see version-history-tab.tsx / client-offer-view-labels.ts
 * for the closest siblings, each still inlined for their own feature).
 */

/** Formats a nullable PLN amount as e.g. "5 200 zł", or "—" when null. */
export function formatOfferedPrice(pln: number | null): string {
  if (pln == null) return '—';
  return `${pln.toLocaleString('pl-PL', { minimumFractionDigits: 0, maximumFractionDigits: 0 })} zł`;
}
